;(function () {
	if (
		!document.querySelector('#dkmv-title') &&
		!document.querySelector('#consorzio-minisite-malghe-anchor')
	) {
		return
	}

	const el = getElement()

	if (!document.querySelector('#consorzio-minisite-malghe-anchor')) {
		// Home page
		const selector = document.querySelector('.boxheader')
		const target = document.querySelector('#dkmv-title')
		selector.parentNode.insertBefore(el, selector.nextSibling)

		el.addEventListener('click', e => {
			target.scrollIntoView({behavior: 'smooth', block: 'start'})
		})
	} else {
		// Prodotti
		const selector = document.querySelector(
			'#consorzio-minisite-malghe-anchor'
		)
		selector.appendChild(el)

		el.addEventListener('click', e => {
			window.location.href = `${
				document.querySelector('.menusci li a').href
			}#dkmv-title`
		})
	}

	function getElement() {
		const el = document.createElement('div')
		el.classList.add('minisite-service-anchor')

		el.innerHTML = `
			<div class="minisite-service-anchor__element">
				<div class="minisite-service-anchor__icon">
					<span class="material-icons">store_mall_directory</span>
				</div>
				<div class="minisite-service-anchor__text">
					<p class="minisite-service-anchor__title">${mL('title')}</p>
					<p class="minisite-service-anchor__copy">${mL('copy')}</p>
				</div>
			</div>
		`

		return el
	}

	function mL(string) {
		const data = {
			title: {
				it: 'Formaggio Asiago Dop',
				en: 'Asiago DOP cheese',
				de: 'Asiago DOP-Käse',
			},
			copy: {
				it: "malghe, caseifici e spacci",
				en: 'mountain huts, dairies and shops',
				de: 'Berghütten, Sennereien und Geschäfte',
			},
		}

		return data[string][WC.lang.substr(0, 2)]
	}
})()
